import type { TourDefinition } from "../types";

export const workOrdersTour: TourDefinition = {
  id: "work-orders",
  titleKey: "onboarding.tours.workOrders.title",
  descriptionKey: "onboarding.tours.workOrders.description",
  module: "work-orders",
  estimatedMinutes: 3,
  steps: [
    {
      id: "work-orders-intro",
      targetSelector: "[data-tour='search-input']",
      titleKey: "onboarding.tours.workOrders.intro.title",
      descriptionKey: "onboarding.tours.workOrders.intro.description",
      placement: "bottom",
      navigateTo: "/work-orders",
      waitForSelector: "[data-tour='search-input']",
    },
    {
      id: "work-orders-add",
      targetSelector: "[data-tour='create-button']",
      titleKey: "onboarding.tours.workOrders.add.title",
      descriptionKey: "onboarding.tours.workOrders.add.description",
      placement: "bottom",
      action: "click",
      actionTarget: "[aria-label='Add Work Order']",
      highlightPulse: true,
    },
    {
      id: "work-orders-title",
      targetSelector: "[role='dialog'] input[name='title']",
      titleKey: "onboarding.tours.workOrders.title_field.title",
      descriptionKey: "onboarding.tours.workOrders.title_field.description",
      placement: "bottom",
      waitForSelector: "[role='dialog']",
    },
    {
      id: "work-orders-priority",
      targetSelector: "[role='dialog']",
      titleKey: "onboarding.tours.workOrders.priority.title",
      descriptionKey: "onboarding.tours.workOrders.priority.description",
      placement: "right",
    },
    {
      id: "work-orders-assignment",
      targetSelector: "[role='dialog']",
      titleKey: "onboarding.tours.workOrders.assignment.title",
      descriptionKey: "onboarding.tours.workOrders.assignment.description",
      placement: "left",
    },
    {
      id: "work-orders-save",
      targetSelector: "[role='dialog'] button[type='submit']",
      titleKey: "onboarding.tours.workOrders.save.title",
      descriptionKey: "onboarding.tours.workOrders.save.description",
      placement: "top",
      celebration: "checkmark",
    },
  ],
};
